<template>
  <div class="search-container">
    <font-awesome-icon :icon="['fa', 'search']" size="1x" class="search-icon">
    </font-awesome-icon>
    <v-select class="search-select" aria-label="Search" label="title"
      @search="debouncedSearch" :options="filteredEvents" v-model="searchString"
      :filterable="false" :clearable="false" :clearSearchOnSelect="false">
      <template slot="no-options">
        Search...
      </template>
      <template slot="option" slot-scope="option">
        <router-link :to="`/event/${option._id}`" class="option-container">
          <img :src="option.pic" />
          <div class="option-details">
            <span class="title">{{ option.title }}</span>
            <span class="location">
              <span v-if="option.isOnline">Online Event</span>
              <span v-else>{{ option.location.title }}</span>
            </span>
          </div>
        </router-link>
      </template>
    </v-select>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';

export default {
  name: 'SearchBar',
  data() {
    return {
      filteredEvents: [],
      searchString: '',
    };
  },
  created() {
    this.debouncedSearch = debounce(this.search, 250);
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
  },
  methods: {
    async search(searchString, loading) {
      loading(true);
      try {
        const eventCategoriesResponse =
          await this.backendAxios.get(`/sponsorship-event/search/${searchString}`);
        this.filteredEvents = eventCategoriesResponse.data;
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
      loading(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.search-container {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 auto 0 1rem;
  width: 32rem;
  height: 2.25rem;
}

.search-icon {
  position: absolute;
  left: 0.5rem;
  color: $search-theme;
}

.search-select {
  height: 100%;
  width: 100%;
  font-size: 1rem;
  padding: 0 0 0 2rem;
  border: solid 1px #ccc;
  border-radius: 3px;
}

.option-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration: none;
  color: #444444;
}

.option-container img {
  width: 3rem;
  height: 3rem;
}

.option-container .option-details {
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
}

.option-details .title {
  font-size: 1rem;
  font-weight: bold;
}

.option-details .location {
  font-size: 0.8rem;
}

@media screen and (max-width: 814px) {
  .search-container {
    width: 100%;
    margin-right: 1rem;
  }
}

</style>

<style lang="scss">

.search-select .vs__search {
  color: #000000 !important;
}

.search-select .dropdown-toggle {
  border: none !important;
}

.search-select .open-indicator {
  display: none !important;
}

</style>
